import { render, staticRenderFns } from "./base-card.vue?vue&type=template&id=60d66cd5&scoped=true&"
import script from "./base-card.vue?vue&type=script&lang=js&"
export * from "./base-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d66cd5",
  null
  
)

export default component.exports